import multiRequest from '../shared/multiRequest';
import bffMultiChannelRequest from '../shared/bffMultiChannelRequest';

const getNetworkIssuesWarn = () => {
  return multiRequest([
    {
      url: 'customer/network-issues/warn',
      method: 'GET',
    },
  ]);
};

const getRefreshAvailability = () => {
  return multiRequest([
    {
      url: 'customer/ota/refreshAvailability',
      method: 'GET',
    },
  ]);
};

const patchRefresh = () => {
  return multiRequest([
    {
      url: 'customer/ota/refresh',
      method: 'PATCH',
    },
  ]);
};

const putReport = () => {
  return multiRequest([
    {
      url: 'customer/network-issues/report',
      method: 'PUT',
    },
  ]);
};

const getReportAvailability = () => {
  return multiRequest([
    {
      url: 'customer/network-issues/report',
      method: 'GET',
    },
  ]);
};

const getMassivesIssues = () => {
  return bffMultiChannelRequest([
    {
      url: `bff-network-issues/warn`,
      method: 'GET',
    },
  ]);
};

const NetworkIssuesService = {
  getNetworkIssuesWarn,
  getRefreshAvailability,
  patchRefresh,
  putReport,
  getReportAvailability,
  getMassivesIssues,
};

export default NetworkIssuesService;
